import { htmlElem } from './globals';
const indexClass = 'index';

const indexPage = () => {
    const arrPaths = document.location.pathname.split('/');
    const primaryDir = arrPaths[1];
    let pathnames = arrPaths
        .map(item => item.toLowerCase())
        .filter(item => item !== '');
    htmlElem.removeAttribute('class');
    if (!primaryDir || primaryDir === 'index') {
        htmlElem.classList.add(indexClass);
    } else {
        htmlElem.classList.add(...pathnames);
        htmlElem.classList.remove(indexClass);
    }
};

export {
    indexPage
}